import MediaBreakpoints from 'media-breakpoints';

export default new MediaBreakpoints({
  XS: 0,
  SM: 560,
  MD: 768,
  LG: 992,
  XL: 1200,
});
